import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

const PdfSongs = () => {
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pdfs, setSongs] = useState([]);
  const [error, setError] = useState(null);

  const API_URL =
    process.env.REACT_APP_API_URL || "http://45.194.3.128:4000/api/admin/";

  useEffect(() => {
    const fetchPdfSongs = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${API_URL}songs-pdf-list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error("Failed to fetch songs");

        const data = await response.json();

         if (!response.ok || data.success === false) {
          // 🔑 Handle invalid token
          if (data.message === 'Invalid token') {
            localStorage.removeItem('token');
            window.location.href = '/login';
            return;
          }
      }

        setSongs(data.data || []);

        
      } catch (err) {
        setError("Unable to load PDF songs list.");
        console.error("Error fetching songs:", err);
      } finally {
        setLoading(false);
      }

    };

    fetchPdfSongs();
  }, []);

  return (
    <>
      <Helmet>
        <title>PDF Songs - GPN</title>
      </Helmet>

      <div style={{ padding: "20px" }}>
        <h2 style={{ marginBottom: "20px" }}>PDF Songs</h2>

        {error && <p style={{ color: "red" }}>{error}</p>}
        {loading && <p style={{ color: "white", display: "flex", justifyContent: "center", fontSize: "16px" }}>Loading songs...</p>}

        {pdfs.length === 0 && !error && !loading && <p style={{ color: "white", display: "flex", justifyContent: "center", fontSize: "16px" }}>No PDF songs available.</p>}

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >


          {pdfs.map((song) => (
            <div
              key={song.id}
              style={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "16px",
                width: "220px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                textAlign: "center",
              }}
            >
              <h3
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  marginBottom: "10px",
                }}
              >
                {song.title}
              </h3>
              <button
                onClick={() => setSelectedPdf(song.song_url)}
                style={{
                  marginTop: "8px",
                  padding: "8px 12px",
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                View PDF
              </button>
            </div>
          ))}
        </div>

        {/* Modal */}
        {selectedPdf && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2000,
            }}
            onClick={() => setSelectedPdf(null)}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "10px",
                padding: "10px",
                width: "90vw",
                height: "90vh",
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setSelectedPdf(null)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "#EF4444",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  padding: "6px 10px",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>

              <iframe
                src={selectedPdf}
                title="PDF Viewer"
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
                onError={() => alert("Failed to load PDF.")}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PdfSongs;
